import { TRIGGER_FORMATS } from "../../../actions";

export default function (showFormats, action) {
  switch (action.type) {
    case TRIGGER_FORMATS:
      return !showFormats;
    default:
      return showFormats;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/elements/formats/index.js